import { literal, number, struct } from 'io-ts/lib/Decoder';

import { Id as FloorLevel } from '../../../ai/floor-level/Id';

const AlignmentOffsets = struct({
	horizontalOffsetPx: number,
	verticalOffsetPx: number,
});

/**
 * Sent when the user confirms the alignment step for a floor level.
 * alignment.horizontal_offset_px and alignment.vertical_offset_px are the
 * pixel-space shifts to apply to Level N so it visually aligns with Level 1.
 */
export const AlignmentUpdated = struct({
	type: literal('alignment-updated'),
	floorLevel: FloorLevel,
	alignment: AlignmentOffsets,
});
